import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
//icons
import { FaEdit } from 'react-icons/fa';
import { AiFillDelete, AiOutlineEye } from 'react-icons/ai';
import { GiBroom } from 'react-icons/gi';
import { BsSearch } from 'react-icons/bs';
//api
import { getBlogPosts } from 'api/libelista';
//helpers
import { formatDateToSpanish } from 'helpers';
//context
import { useGlobalContext } from 'context/globalContext';
//components
import CustomInput from 'components/backoffice/customInput';
import CustomTable from 'components/backoffice/customTable';
import DropdownIcons from 'components/backoffice/dropDownIcons';
import Button from 'components/backoffice/buttonCustom';
import SearchTable from 'components/backoffice/table/SearchTable';


const colsBlogPosts = [
  'Título',
  'Autor',
  'Fecha de publicación',
  'Párrafo destacado',
  'Tipo de publicación',
  ''
];

const BlogPosts = () => {
  const navigate = useNavigate();
  const [listBlogPosts, setListBlogPosts] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [noResults, setNoResults] = useState(false);
  const [totalPages, setTotalPages] = useState(null);
  const [isActiveSearch, setIsActiveSearch] = useState(false);
  const { isLoading, setIsLoading } = useGlobalContext();
  const { t } = useTranslation(['backoffice']);

  const query = {
    page: 1,
    page_size: 10,
  };
  const searchQuery = new URLSearchParams(query);
  const queryString = searchQuery.toString();

  const getListBlogPosts = async () => {
    setIsLoading(true);
    const { data, status } = await getBlogPosts(queryString);

    if (status === 200 && data?.results.length > 0) {
      setListBlogPosts(data?.results);
      setNoResults(false);
    } else {
      setListBlogPosts([]);
      setNoResults(true);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getListBlogPosts();
  }, []);

  const handleClear = () => {
    setNoResults(false);
    navigate('/intranet/blog-posts');
  };

  return (
    <div className="h-100">
      <div className="d-flex mt-3 justify-content-between">
        <h1 className="text-light mt-5">Publicaciones de blog</h1>
      </div>
      <div className=" d-flex justify-content-between">
        <SearchTable value={inputValue} handleClear={handleClear} />
        <Col md={1} className="text-end mt-3">
          <Button color={'primary'}>{t('crear')}</Button>
        </Col>
      </div>
      <CustomTable cols={colsBlogPosts} noResults={noResults} isLoading={isLoading} page={1}>
        {listBlogPosts &&
          listBlogPosts.map((listBlogPost, index) => {
            return (
              <tr key={listBlogPost.id}>
                <t>{listBlogPost.title}</t>
                <td>{listBlogPost.author}</td>
                <td>{formatDateToSpanish(listBlogPost.publish_date)}</td>
                <td>{listBlogPost.featured_paragraph}</td>
                <td>{listBlogPost.selected_type_post.name}</td>
                <td className="item-dropdown text-end">
                  <DropdownIcons idItem={index} />
                </td>
              </tr>
            );
          })}
      </CustomTable>
    </div>
  );
};

export default BlogPosts;
